import React from 'react';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { KatButton } from '@amzn/katal-react';
import { CountryCode } from '../urls-config';
import { BrandRegistryInfoAlertBox } from './BrandRegistryInfoAlertBox';
import { AuthenticationState } from './hooks/useTrimContext';

const ReportAViolation = React.lazy(() =>
  import(
    /* webpackChunkName: 'ReportAViolation' */ '@amzn/rav-report-a-violation/dist'
  ).then((library) => ({ default: library.ReportAViolation }))
);
interface PublicNoticeFormPageProps {
  authenticationState?: AuthenticationState;
  domainCountryCode: CountryCode;
  routerProps: any;
  userFirstName: string;
}

const PnfLandingPage: React.FC<PublicNoticeFormPageProps> = (props: PublicNoticeFormPageProps) => {
  const { t } = useTranslation('pnf_website_components');
  const {
    authenticationState,
    domainCountryCode,
    routerProps,
    userFirstName,
  } = props;

  const [isReportStarted, setIsReportStarted] = React.useState(false);

  const handleSignOutClick = () => {
    window.location.href = authenticationState?.signOutUrl || '';
  };
  const handleRetractReportClick = () => {
    window.location.href = '/report/infringement/retract';
  };
  const handleStartReportClick = () => {
    setIsReportStarted(true);
  };
  return isReportStarted ? (
    <ReportAViolation {...routerProps} />
  ) : (
    <div className="page-padding">
      {/* Page container for page level padding */}
      <Row className="d-flex justify-content-between">
        <Col xs="6">
          <Row className="pt-4">
            <Col xs="12">
              <h1>{t('public-notice-form-header')}</h1>
            </Col>
          </Row>
          <Row className="pt-2">
            <Col xs="12">
              <h2>{t('public-notice-form-instructions-title')}</h2>
              {/* TODO: Deprecate country specific strings; generate links with string interpolation */}
              <span dangerouslySetInnerHTML={{ __html:
                  t([`public-notice-form-instructions-${domainCountryCode.toLowerCase()}`,
                    'public-notice-form-instructions']) }}
              />
            </Col>
          </Row>
          <Row className="pt-2">
            <Col xs="12">
              <h2>{t('public-notice-form-we-do-not-enforce-title')}</h2>
              {/*
               TODO: Deprecate country specific strings; split string content to render
                based on what is supported in the domain marketplace
               */}
              <span dangerouslySetInnerHTML={{ __html:
                  t([`public-notice-form-we-do-not-enforce-instructions-${domainCountryCode.toLowerCase()}`,
                    'public-notice-form-we-do-not-enforce-instructions']) }}
              />
            </Col>
          </Row>
          <Row className="pt-2">
            <Col xs="12">
              <div className="d-flex justify-content-between">
                <KatButton
                  className="ml-2"
                  id="pnf-website-sign-out-button"
                  variant="tertiary"
                  onClick={handleSignOutClick}
                >
                  {t('public-notice-form-sign-out-button', {
                    givenName: '{{givenName}}',
                  }).replace('{{givenName}}', userFirstName)}
                </KatButton>
                <div>
                  <KatButton
                    className="ml-2"
                    id="pnf-website-retract-report-button"
                    variant="secondary"
                    onClick={handleRetractReportClick}
                  >
                    {t('public-notice-form-retract-report')}
                  </KatButton>
                  <KatButton
                    className="ml-2"
                    id="pnf-website-start-report-button"
                    variant="primary"
                    onClick={handleStartReportClick}
                  >
                    {t('public-notice-form-start-report')}
                  </KatButton>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs="4">
          {
            domainCountryCode !== CountryCode.CN &&
            <BrandRegistryInfoAlertBox
              domainCountryCode={domainCountryCode}
            />
          }
        </Col>
      </Row>
    </div>
  );
};

export default PnfLandingPage;
